import { api } from '../api';
export const configApi = api.injectEndpoints({
    endpoints: (build) => ({
        getConfig: build.query({
            query: (args) => ({
                url: `program-service/api/v1/widget/config`,
                headers: {
                    'X-Loyalty-Language': (args.locale).split('-')[0],
                    'Authorization': `Bearer ${args.jwt}`
                }
            })
        })
    })
});
//# sourceMappingURL=config.api.js.map